import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse, faWallet, faBolt, faHeadset, faMagnifyingGlass, faChartLine, faClock } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom"
import { useUser } from "../utils/UserContext";
import { formatCurrency, getRate } from '../utils/currencyUtils';
import { Toaster } from 'react-hot-toast';
import EmailVerifyModal from "../components/EmailVerifyModal";
import 'react-multi-carousel/lib/styles.css';
import feather from 'feather-icons';
import ConnectBar from "../components/ConnectBar";
import logo from "../images/brand/logo.png";
import Carousel from 'react-multi-carousel';
import Select from "react-select";
import DepositHistory from "../components/DepositHistory";

function Dashboard() {
  useEffect(() => {
    feather.replace();
  }, []);
  const { user } = useUser();
  //CLEAR LOCAL Storage
  localStorage.clear();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  //WALET CARD
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [wallet, setWallet] = useState([]);
  const [assethistory, setAssethistory] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwallet: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setWallet(data.wallet);
      }
    })
    .catch(err => {
    })
  }, [user]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          percentage: Number(coin.quote.USD.percent_change_24h.toFixed(2)),
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        amount: 0,
    }));
    const sortedData = updatedData.sort((a, b) => b.price - a.price);
    setStock(sortedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            amount: 0,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const walletMap = wallet.reduce((acc, item) => {
      const key = item.coinName?.trim();
      acc[key] = parseFloat(item.balance) || 0;
      return acc;
    }, {});
    const applyWalletBalance = (list) => {
      let categorySum = 0;
      const result = list.map(item => {
        const key = item.name?.trim();
        const matchedBalance = walletMap[key];
        const amount = matchedBalance || 0;
        const value = amount * item.price;
        categorySum += value;
        return {
          ...item,
          amount
        };
      });
      return { result, categorySum };
    };
    const { result: cryptoWithBalance, categorySum: cryptoSum } = applyWalletBalance(crypto);
    const { result: fiatWithBalance, categorySum: fiatSum } = applyWalletBalance(fiat);
    const { result: stockWithBalance, categorySum: stockSum } = applyWalletBalance(stock);
    const merged = [
      ...cryptoWithBalance,
      ...fiatWithBalance,
      ...stockWithBalance
    ];
    const sorted = merged.sort((a, b) => {
      if (b.amount > 0 && a.amount === 0) return 1;
      if (a.amount > 0 && b.amount === 0) return -1;
      return a.name.localeCompare(b.name);
    });
    setAssethistory(sorted);
  }, [crypto, fiat, stock, wallet, user]);
  const [connectBar, setConnectBar] = useState(false);
  const toggleConnectBar = () => {
    setConnectBar(!connectBar);
  };
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1273 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 1273, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1000, min: 740 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  const responsive1 = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1273 },
      items: 7
    },
    desktop: {
      breakpoint: { max: 1273, min: 1024 },
      items: 5
    },
    tablet: {
      breakpoint: { max: 1000, min: 740 },
      items: 6
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3
    }
  };
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const [activeTab1, setActiveTab1] = useState("all");
  const [deposithistorys, setDeposithistorys] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const filteroptions = [
    { value: "all", label: "All" },
    { value: "success", label: "Success" },
    { value: "pending", label: "Pending" },
    { value: "failed", label: "failed" },
  ];
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchdeposit: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedTrans = data.trans.map(tx => {
        const coinName = tx.method.split(" - ")[0];
        let logo = null;
        let symbol = null;
        const asset = assethistory.find(asset => asset.name === coinName);
        if (asset) {
            logo = asset.logo;
            symbol = asset.symbol;
        }
        return {
            ...tx,
            logo,
            symbol
        };
        });
        setDeposithistorys(updatedTrans);
      }
    })
      .catch(err => {
    })
  }, [user]);
  const filteredHistory = deposithistorys.filter(deposithistory => 
    Object.values(deposithistory).some(value => 
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    ) && 
    (selectedFilter === 'all' || deposithistory.status.toLowerCase() === selectedFilter.toLowerCase())
  )
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <div><Toaster/></div>
        <EmailVerifyModal UserDetails={user} />
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Dashboard" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Dashboard" icon={<FontAwesomeIcon icon={faHouse} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main className="mb-4">
            <div className="row">
              <div className="col-lg-8 col-md-7 col-12">
                <div className="mycard mt-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <Link to="/deposit" className="me-3 px-3 py-2 d-flex align-items-center rounded-2" style={{backgroundColor: '#ffffff06',textDecoration:'none'}}>
                        <FontAwesomeIcon className="text-prime lh-1 me-2" icon={faBolt} style={{fontSize:'14px'}} />
                        <p className="mb-0 fw-semibold text-prime" style={{fontSize: '14px'}}>Deposit now</p>
                      </Link>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-12 g-4">
                      <div className="shadow px-3 py-4 position-relative overflow-hidden" style={{backgroundColor: '#ffffff0d', borderLeft:'2px solid #ff6b35'}}>
                        <img src={require(`../images/map_1.png`)} alt="chart" className="position-absolute" style={{height:'400px', right:'-15%', top:'-15%',zIndex:'1'}}/>
                        <div className="position-relative" style={{zIndex:'2'}}>
                          <p className="mb-2">USD Account</p>
                          <div className="d-xxl-flex align-items-end mb-5" style={{gap:'40px'}}>
                            <div>
                              <h3 className="mb-0 fw-semibold text-prime">{formatCurrency(Number(user?.balance) * rate)} <span className="mb-0 text-white fs-5">{user?.currency}</span></h3>
                              <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>United State Dollar Balance</p>
                            </div>
                            <div className="mt-3 mt-xxl-0">
                              <h4 className="mb-0 fw-semibold">{formatCurrency(user?.bonus * rate)} <span className="mb-0 text-white fs-6">{user?.currency}</span></h4>
                              <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Referral Balance</p>
                            </div>
                          </div>
                          <Link to="/stock" className="rounded bg-prime mb-0 px-4 fw-semibold" style={{textDecoration:'none',fontSize: '14px',paddingTop:'14px',paddingBottom:'14px'}}>Buy Stocks
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-12 g-4">
                      <div className="mycard mt-2 p-3 mt-2">
                        <p className="mb-2 fw-bold fs-5">Quick Links</p>
                        <div className="d-flex align-items-center" style={{gap:'10px', overflowX:'auto'}}>
                          <Link to="/stock" className="mycard shadow px-0 py-2 d-flex flex-column align-items-center noLink" style={{border:'1px solid #009cfc96',cursor:'pointer',minWidth:'95px'}}>
                            <div className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden" style={{backgroundColor:'#009cfc7a',height:'35px',width:'35px'}}>
                              <i data-feather="layers" height="18"></i>
                            </div>
                            <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Stock</p>
                          </Link>
                          <Link to="/deposit" className="mycard shadow px-0 py-2 d-flex flex-column align-items-center noLink" style={{border:'1px solid #009cfc96',cursor:'pointer',minWidth:'95px'}}>
                            <div className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden" style={{backgroundColor:'#009cfc7a',height:'35px',width:'35px'}}>
                              <i data-feather="credit-card" height="18"></i>
                            </div>
                            <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Deposit</p>
                          </Link>
                          <Link to="/withdraw" className="mycard shadow px-0 py-2 d-flex flex-column align-items-center noLink" style={{border:'1px solid #009cfc96',cursor:'pointer',minWidth:'95px'}}>
                            <div className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden" style={{backgroundColor:'#009cfc7a',height:'35px',width:'35px'}}>
                              <i data-feather="package" height="18"></i>
                            </div>
                            <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Withdraw</p>
                          </Link>
                          <Link to="/assets" className="mycard shadow px-0 py-2 d-flex flex-column align-items-center noLink" style={{border:'1px solid #009cfc96',cursor:'pointer',minWidth:'95px'}}>
                            <div className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden" style={{backgroundColor:'#009cfc7a',height:'35px',width:'35px'}}>
                              <i data-feather="grid" height="18"></i>
                            </div>
                            <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Assets</p>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-container mt-2" style={{maxWidth: '1100px'}}>
                  <Carousel responsive={responsive1}
                    swipeable={true}
                    draggable={true}
                    showDots={false}
                    ssr={true}
                    infinite={true}
                    autoPlay={true}
                    keyBoardControl={true}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
                  >
                    {stock.map((stocklist) => {
                      const randomChart = ['redchart.png', 'yellowchart.png', 'bluechart.png', 'graychart.png'][Math.floor(Math.random() * 4)];
                      return (
                        <div key={stocklist.id} className="mycard d-flex align-items-center flex-column p-0 me-2 me-lg-3" style={{backgroundColor: '#ffffff1c'}}>
                          <img src={stocklist.logo} alt={stocklist.name} style={{width: '30px'}} className="mt-3 mb-4" />
                          <img src={require(`../images/${randomChart}`)} alt="chart" style={{height: '42px'}} className="w-100 mb-2"/>
                        </div>
                      );
                    })}
                  </Carousel>
                </div>
                <div className="mt-2 d-flex flex-column align-items-center" style={{maxWidth: '100%'}}>
                  <h5 className="fw-bold mt-4">Investments made easy</h5>
                  <p style={{fontSize: '14px'}}>Begin your stock investment journey today</p>
                  <Link to="/Stock" className="myBtn bg-prime fw-bold rounded-0 py-3 text-center" style={{maxWidth: '400px',width: '100%'}}>Explore Stocks</Link>
                </div>
              </div>
              <div className="col-lg-4 col-md-5 col-12">
                <div className="mycard mt-2" style={{background: 'linear-gradient(to top, #ff6b3521 5%, #ffffff06 95%)'}}>
                  <div className="carousel-container mt-2" style={{maxWidth: '1100px'}}>
                    <Carousel responsive={responsive} swipeable={true} draggable={true} showDots={false} ssr={true} arrows={false} infinite={true} autoPlay={true} autoPlaySpeed={2000} keyBoardControl={true} containerClass="carousel-container" removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}>
                      <div>
                        <div className="d-flex align-items-center justify-content-between">
                          <img src={logo} alt="logo" className="app-logo"/>
                          <span className="rounded-3 fw-semibold px-2 py-1 bg-prime" style={{fontSize:'14px'}}>Trending</span>
                        </div>
                        <h2 className="fw-normal mt-4">Stock Investments</h2>
                        <p className="text-secondary fw-semibold mb-0 pb-xxl-5">Diversify your portfolio by investing in leading companies and trending global stocks.</p>
                        <div className="rounded-3 bg-prime mb-0 px-4 fw-semibold mt-5 text-center" style={{textDecoration:'none',paddingTop:'14px',paddingBottom:'14px',cursor:'pointer'}} onClick={() => {toggleConnectBar()}}>Connect with Wallet <FontAwesomeIcon className="ms-2 text-white" icon={faWallet} /></div>
                        <Link to="/stock" className="rounded-3 mb-0 px-4 fw-semibold mt-2 text-center stake-button d-block mt-3" style={{textDecoration:'none',paddingTop:'14px',paddingBottom:'14px',cursor:'pointer'}} onClick={() => {toggleConnectBar()}}>Trade Stocks <FontAwesomeIcon className="ms-2 text-white" icon={faChartLine} /></Link>
                      </div>
                    </Carousel>
                  </div>
                </div>
                <div className="mycard shadow p-3 mt-2 position-relative" style={{border:'1px solid #ffffff17'}}>
                  <div style={{width:'70%'}}>
                    <h4 className="mb-4 fw-bold">Looking For a Partnership With Optiglobalcapital?</h4>
                    <p className="text-secondary mb-4">If You're Searching For A Collaboration That Revolves Around</p>
                    <h4 className="mb-0 fw-bold">Need Help?</h4>
                    <p className="mb-0 text-prime mt-2" style={{fontSize:'14px'}}><FontAwesomeIcon className="text-prime me-1" icon={faHeadset} /> Contact our Support</p>
                  </div>
                  <img src="./uploads/partner.png" alt="image" className="position-absolute" style={{width:'32%', bottom:'20px', right:'20px'}}/>
                </div>
              </div>
              <div className="col-12 mt-3">
              <div className="mycard p-3">
                  <div className="d-flex align-items-center">
                    <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Recommended stock for 24 hours</p>
                    <FontAwesomeIcon className="ms-2 text-prime" icon={faClock} style={{fontSize: '14px'}} />
                  </div>
                  <h1 className="mb-0 fe-semibold">Top stocks by market value</h1>
                  <div className="row">
                    {stock.slice(0, 12).map((stockSingle) => (
                    <div className="col-lg-3 col-md-6 g-4">
                      <div className="mycard shadow p-3" style={{border:'1px solid #ffffff17'}}>
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center justify-content-center oveflow-hidden rounded-2" style={{backgroundColor:'#ffffff17',height:'40px',width:'40px'}}>
                              <img src={stockSingle.logo} alt="BTC" style={{width: '25px'}}/>
                            </div>
                            <div className="ms-2">
                              <p className="mb-0 fw-semibold">{stockSingle.name.length > 12 ? stockSingle.name.slice(0, 20) + '...' : stockSingle.name}</p>
                              <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>[{stockSingle.symbol}]</p>
                            </div>
                          </div>
                          <a href={`/stocklist?symbol=${encodeURIComponent(stockSingle.symbol)}`} className="rounded-circle d-flex align-items-center justify-content-center" style={{border:'2px solid #ffffff17', width:'35px', height:'35px'}}>
                            <i data-feather="arrow-up-right" className="text-prime" height="18"></i>
                          </a>
                        </div>
                        <p className="mb-0 text-secondary fw-semibold mt-2" style={{fontSize:'14px'}}>Stock Price</p>
                        <p className="mb-0 fw-semibold" style={{fontSize:'18px'}}>{formatCurrency(stockSingle.price)} USD</p>
                      </div>
                    </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-12 mt-3">
                <div className="d-flex align-items-center justify-content-between flex-wrap mb-3" style={{gap:'10px'}}>
                    <div className="d-flex align-items-cemter overflow-x-auto mx-2" style={{cursor:'pointer'}}>
                        <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab1 === "pending" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab1 === "pending" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab1("pending");}}>Pending Deposit</h6>
                        <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab1 === "all" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab1 === "all" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab1("all");}}>All Deposit</h6>
                    </div>
                    <div className="d-flex align-items-center me-3">
                        <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                        <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                        <input 
                            type="text" 
                            placeholder="Search for deposits" 
                            className="searchinput"
                            value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        </div>
                        <Select 
                            options={filteroptions}
                            value={filteroptions.find((opt) => opt.value === selectedFilter)}
                            onChange={(e) => setSelectedFilter(e.value)}
                            styles={darkThemeStyles}
                            className="w-full"
                        />
                    </div>
                </div>
                {activeTab1 === "pending" && (
                <div className="mycard">
                    <div className="table-responsive">
                        <table className="table table-borderless table-dark align-middle">
                            <thead>
                                <tr className="fs-7">
                                <th className="fw-normal text-light d-md-table-cell d-none" style={{width: '150px'}}>Date</th>
                                <th className="fw-normal text-light d-md-none d-table-cell">ID</th>
                                <th className="fw-normal text-light d-md-table-cell d-none">Reference</th>
                                <th className="fw-normal text-light d-md-table-cell d-none">Type</th>
                                <th className="fw-normal text-light d-md-table-cell d-none">Method</th>
                                <th className="fw-normal text-light d-md-table-cell d-none">Deposit Type</th>
                                <th className="fw-normal text-light">Amount</th>
                                <th className="fw-normal text-light">Status</th>
                                <th className="fw-normal text-light d-md-none d-table-cell"></th>
                                </tr>
                            </thead>
                            <tbody style={{fontSize: '14px'}}>
                            {filteredHistory.length > 0 ? (
                                filteredHistory.map((history, index) =>
                                    history?.status === "pending" ? (
                                        <DepositHistory key={history.id || index} index={index} history={history} />
                                    ) : null
                                )
                            ) : (
                                <tr>
                                    <td className="py-5" colSpan={7}>You have not made any deposits yet.</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
                )}
                {activeTab1 === "all" && (
                <div className="mycard">
                    <div className="table-responsive">
                        <table className="table table-borderless table-dark align-middle">
                            <thead>
                                <tr className="fs-7">
                                <th className="fw-normal text-light d-md-table-cell d-none" style={{width: '150px'}}>Date</th>
                                <th className="fw-normal text-light d-md-none d-table-cell">ID</th>
                                <th className="fw-normal text-light d-md-table-cell d-none">Reference</th>
                                <th className="fw-normal text-light d-md-table-cell d-none">Type</th>
                                <th className="fw-normal text-light d-md-table-cell d-none">Method</th>
                                <th className="fw-normal text-light d-md-table-cell d-none">Deposit Type</th>
                                <th className="fw-normal text-light">Amount</th>
                                <th className="fw-normal text-light">Status</th>
                                <th className="fw-normal text-light d-md-none d-table-cell"></th>
                                </tr>
                            </thead>
                            <tbody style={{fontSize: '14px'}}>
                            {filteredHistory.length > 0 ? (
                                filteredHistory.map((history, index) => (
                                    <DepositHistory index={index} history={history}/>
                                ))
                            ) : (
                                <tr>
                                    <td className="py-5" colSpan={7}>You have not made any deposits yet.</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
                )}
              </div>
            </div>
          </main>
        </div>
      </div>
      <ConnectBar toggleConnectBar={toggleConnectBar} connectBar={connectBar}/>
    </div>
  )
}

export default Dashboard